const getters = {
  getLogTimes: state => state.logTimes
}

const actions = {
  setLogTimes ({ commit }, data) {
    commit('setLogTimes', data)
  }
}

const mutations = {
  setLogTimes (state, data) {
    state.logTimes = data
  }
}

const state = {
  logTimes: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
